<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start" *ngIf="!(cordova && (userData.role === 'lender' || userData.role === 'agentAdmin'))">
      <ion-back-button routerDirection="back" data-cy="profile-hdr-backBtn"></ion-back-button>
      <ion-menu-button class="ionMenuButtonCls" autoHide="true"></ion-menu-button>
    </ion-buttons>

    <ion-buttons slot="end">

      <ion-button *ngIf="!offlineMode" (click)="openHelp()" data-cy="profile-hdr-helpBtn">
        <ion-icon slot="icon-only" name="help-circle-sharp"></ion-icon>
      </ion-button>

      <ion-button *ngIf="offlineMode" (click)="common.openOfflineModal()">
        <ion-icon slot="icon-only" name="cloud-offline-outline"></ion-icon>
      </ion-button>

    </ion-buttons>
    <ion-title *ngIf="userData?.role !== 'agentAdmin'" data-cy="profile-hdr-title">Profile</ion-title>
    <ion-title *ngIf="userData?.role === 'agentAdmin'" data-cy="profile-hdr-title">Account</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content padding="true" class="manual-remove-top-padding has-header">

  <ion-fab *ngIf="shouldShowDebugMenu" slot="fixed" vertical="bottom" horizontal="start" style="margin: 0 20px 20px 0;">

    <ion-fab-button (click)="onDebugMenuButtonClick()" color="warning">
      <ion-icon name="hammer-outline" />
    </ion-fab-button>
  </ion-fab>

  <div class="profileWrapper" *ngIf="!cordova || (userData.role === 'agent')">

    <div id="leftProfileDiv" class="profileDiv" [ngClass]="screenType">
      <div class="blockBox">
        <!-- PROFILE IMAGE -->
        <div class="spacer-10"></div>

        <div class="margin-auto text-center">
          <form>
            <input class="inputImageElement" id="micrositeProfileFileInput" name="requestfile" onclick="this.value=null"
              type="file" accept='image/*' (change)="onFileChanged($event, 'profile')" #micrositeProfileFileInput>
          </form>

          <div *ngIf="!myProfilePhoto || !myProfilePhoto.id" class="link addImageDiv color-primary dashed"
            (click)="addImageClicked('profile')" data-cy="profile-myInfo-addProfPhoto-placeholder">
            <div class="imageThumbnail"><img src="assets/imgs/imageThumbnail.png"></div>
            <label class="link">Add Photo</label>

          </div>

          <div *ngIf="myProfilePhoto && myProfilePhoto.id && userData.profilePhoto && userData.profilePhoto.length > 0">
            <app-thumbnail class="thumbnailProfile link" (deleted)="onProfileImageDelete(myProfilePhoto)"
              (click)="addImageClicked('profile')" existLabel="" [aspectRatio]="1" [profileImage]="myProfilePhoto"
              profileImage="true" data-cy="profile-myInfo-profPhoto">
            </app-thumbnail>
          </div>
        </div>

        <div class="profileInputsWrapper">
          <ion-item mode="md" lines="none" button="true" detail="false" (click)="updateUserInformations(1)">
            <ion-label class="profile-lbl" slot="start" data-cy="profile-myInfo-name-txt">Name</ion-label>
            <ion-label class="profile-value" slot="end" data-cy="profile-myInfo-name-input">{{userData?.username}}
            </ion-label>
          </ion-item>
          <ion-item mode="md" lines="none" button="true" detail="false" (click)="updateUserInformations(2)">
            <ion-label class="profile-lbl" slot="start" data-cy="profile-myInfo-phone-txt">Phone</ion-label>
            <ion-label class="profile-value" slot="end" data-cy="profile-myInfo-phone-input">{{userData?.phoneNumber |
              phoneFormat}}</ion-label>
          </ion-item>
          <ion-item mode="md" lines="none" button="true" detail="false" (click)="updateUserInformations(3)">
            <ion-label class="profile-lbl" slot="start" data-cy="profile-myInfo-email-txt">Email</ion-label>
            <ion-label class="profile-value" slot="end" data-cy="profile-myInfo-email-input">{{userData?.email}}
            </ion-label>
          </ion-item>
          <ion-item mode="md" lines="none" button="true" detail="false" (click)="updateUserInformations(4)">
            <ion-label class="profile-lbl" slot="start" data-cy="profile-myInfo-password-txt">Password</ion-label>
            <ion-label class="profile-value" slot="end" data-cy="profile-myInfo-password-input">********</ion-label>
          </ion-item>
        </div>
      </div>

      <div class="locked-items">
        <div class="profileInputsWrapper">

          <ion-item mode="md" lines="none" button="true" detail="false" (click)="updateUserInformations(13)"
            class="website" [ngClass]="{ 'is-locked': isLocked(lockedElements?.website) }">
            <ion-label class="profile-value" slot="end" data-cy="profile-myInfo-website-input">{{userData?.website ||
              '--'}}</ion-label>
            <ion-label class="profile-lbl" slot="start" data-cy="profile-myInfo-website-txt">Website
              <span *ngIf="userRole !== 'lender' && getLockImage(lockedElements?.website) !== ''">
                <ion-button fill="clear" size="small" (click)="updateUserInformations(13,'lock', $event)">
                  <ion-icon [src]="getLockImage(lockedElements?.website)" class="link"
                    [ngClass]="{ 'is-locked': isLocked(lockedElements?.website) }"
                    data-cy="profile-myInfo-website-lock"></ion-icon>
                </ion-button>
              </span>
            </ion-label>
          </ion-item>

          <ion-item mode="md" *ngIf="(userRole === 'lender')" lines="none" button="true" detail="false"
            (click)="updateUserInformations(12)">
            <ion-label class="profile-lbl" slot="start" data-cy="profile-myInfo-team-txt">Team Name</ion-label>
            <ion-label class="profile-value" slot="end" data-cy="profile-myInfo-team-input">{{userData?.teamname ||
              '--'}}</ion-label>
          </ion-item>

          <ion-item *ngIf="userData?.role !== 'lender'" mode="md" lines="none" button="true" detail="false"
            (click)="updateUserInformations(5)" class="company"
            [ngClass]="{ 'is-locked': isLocked(lockedElements?.company) }">
            <ion-label style="min-width: 170px;" class="profile-lbl" slot="start"
              data-cy="profile-myInfo-company-txt">Company
              <span *ngIf="userRole !== 'lender' && getLockImage(lockedElements?.company) !== ''">
                <ion-button fill="clear" size="small" (click)="updateUserInformations(5,'lock', $event)">
                  <ion-icon [src]="getLockImage(lockedElements?.company)" class="link"
                    [ngClass]="{ 'is-locked': isLocked(lockedElements?.company) }"
                    data-cy="profile-myInfo-company-lock"></ion-icon>
                </ion-button>
              </span>
            </ion-label>
            <ion-label class="profile-value" slot="end" data-cy="profile-myInfo-company-input">{{userData?.company ||
              '--'}}</ion-label>
          </ion-item>

          <ion-item *ngIf="userData?.role === 'agentAdmin'" mode="md" lines="none" button="true" detail="false"
            (click)="updateUserInformations(15)" class="company"
            [ngClass]="{ 'is-locked': isLocked(lockedElements?.brokerOfRecord) }">
            <ion-label style="min-width: 170px;" class="profile-lbl" slot="start"
              data-cy="profile-myInfo-brokerOfRecord-txt">Broker of Record
              <span *ngIf="userRole === 'agentAdmin' && getLockImage(lockedElements?.brokerOfRecord) !== ''">
                <ion-button fill="clear" size="small" (click)="updateUserInformations(15,'lock', $event)">
                  <ion-icon [src]="getLockImage(lockedElements?.brokerOfRecord)" class="link"
                    [ngClass]="{ 'is-locked': isLocked(lockedElements?.brokerOfRecord) }"
                    data-cy="profile-myInfo-brokerOfRecord-locl"></ion-icon>
                </ion-button>
              </span>
            </ion-label>
            <ion-label class="profile-value" slot="end"
              data-cy="profile-myInfo-brokerOfRecord-input">{{userData?.brokerOfRecord ||
              '--'}}</ion-label>
          </ion-item>

          <ion-item *ngIf="userData?.role === 'lender'" mode=" md" lines="none" button="true" detail="false"
            (click)="updateUserInformations(14)" class="company"
            [ngClass]="{ 'is-locked': isLocked(lockedElements?.company) }">
            <ion-label style="min-width: 170px;" class="profile-lbl" slot="start"
              data-cy="profile-myInfo-broker-txt">Bank / Broker Name
              <span *ngIf="userRole !== 'lender' && getLockImage(lockedElements?.company) !== ''">
                <ion-button fill="clear" size="small" (click)="updateUserInformations(5,'lock', $event)">
                  <ion-icon [src]="getLockImage(lockedElements?.company)" class="link"
                    [ngClass]="{ 'is-locked': isLocked(lockedElements?.company) }"></ion-icon>
                </ion-button>
              </span>
            </ion-label>
            <ion-label class="profile-value" slot="end" data-cy="profile-myInfo-broker-input">{{userData?.company ||
              '--'}}</ion-label>
          </ion-item>


          <!-- (click)="updateUserInformations(2)" -->
          <ion-item mode="md" lines="none" detail="false" *ngIf="(userRole === 'agent' && agentAdminName)">
            <ion-label class="profile-lbl" slot="start" data-cy="profile-myInfo-phone-txt"
              style="vertical-align: middle;">Team Admin</ion-label>
            <ion-label class="profile-value" slot="end" data-cy="profile-myInfo-phone-input">
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <span
                  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 75%;">{{agentAdminName
                  }}</span>
                <ion-button size="small" fill="clear" class="slim-button" (click)="presentPopover($event)" icon-only>
                  <ion-icon color="primary" name="ellipsis-vertical"></ion-icon>
                </ion-button>
              </div>
            </ion-label>
          </ion-item>

        </div>

        <div class="profileInputsWrapper nomarginInputWrapper"
          *ngIf="(userRole === 'agent' && !agentAdminName && loaded)">

          <div style="position: relative;">
            <div class="mediumHeaderText inviteAdminHeader" data-cy="profile-myInfo-team-input">Invite Team Admin
              <ion-icon class="info-icon" color="primary" tappable (click)="activateInfoAlert(9)"
                ios="information-circle-sharp" md="information-circle-sharp">
              </ion-icon>
            </div>

            <algolia-search-with-invite class="algolia-input" [instanceName]="instanceName"
              roleOfUserToInvite="agentAdmin" noResultsMessage="Enter Team Admin's email to invite them" />

          </div>

          <div class="spacer-10"></div>

          <!-- PENDING ADMIN INVITES -->
          <div>
            <div class="list-item" *ngFor="let invite of adminInvites; let i = index">
              <ion-row>
                <ion-col [size]="12" class="profile-item">
                  <div>
                    <app-public-profile-item [showControls]="false" [showContact]="false"
                      class="listing-item hit-border" [user]="invite" publicProfileType="my-profile" [showInvite]="true"
                      [attr.data-index]="i">
                    </app-public-profile-item>
                  </div>
                </ion-col>
              </ion-row>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="rightProfileDiv" class="profileDiv">

      <div class="blockBox">

    

        <div class="segmentSectionOverflow">
          <div class="segmentSection">
            <button #brandingElement class="segmentButton"
              [ngClass]="{'enabledSegment' : (segmentValue === 'branding')}"
              (click)="segmentChanged('branding', brandingElement)" data-cy="profile-myBrand-title">
              Branding
            </button>
            <button #legalElement class="segmentButton"
              [ngClass]="{'enabledSegment' : (segmentValue === 'integrations')}"
              (click)="segmentChanged('integrations', legalElement)" data-cy="profile-legalInfo-title">
              Integrations
            </button>
            <button #additionalOptionsElement class="segmentButton" *ngIf="userData.role !== 'agentAdmin'"
              [ngClass]="{'enabledSegment' : (segmentValue === 'additional')}"
              (click)="segmentChanged('additional', additionalOptionsElement)" data-cy="profile-additionalOpt-title">
              Additional Options
            </button>
            <button #additionalOptionsElement class="segmentButton" *ngIf="userData.role === 'agentAdmin'"
              [ngClass]="{'enabledSegment' : (segmentValue === 'disclosures')}"
              (click)="segmentChanged('disclosures', additionalOptionsElement)" data-cy="profile-disclosuresOpt-title">
              Disclosures
            </button>
          </div>
        </div>

        <div class="segmentDiv" [ngSwitch]="segmentValue">

          <section *ngSwitchCase="'branding'">

            <div class="spacer-20"></div>

            <input class="inputImageElement" id="profileLogoFileInput" onclick="this.value=null" type="file"
              accept='image/*' (change)="onFileChanged($event, 'logo')" #profileLogoFileInput>

            <div class="addImageButton" [ngClass]="{'dashed' : !userData.logoFile}">

              <div (click)="addImageClicked('logo')" *ngIf="userData.logoFile" class="my-brand-wrap__drop link"
                data-cy="profile-myBrand-logo-addBtn">
                <img *ngIf="logoLoaded" class="logoImgElement link" [src]="logoFile | safe: 'url'" />
                <ion-spinner *ngIf="uploadingLogo"></ion-spinner>
              </div>

              <div (click)="addImageClicked('logo')" *ngIf="!userData.logoFile" class="link margin-auto"
                data-cy="profile-myBrand-logo-editBtn">
                <div class="imageThumbnail"><img src="assets/imgs/imageThumbnail.png"></div>
                <span>Tap to add your logo or select your logo below</span>
              </div>

              <div class="vertical-buttons">
                <img *ngIf="isLogoEditable" class="pencilImg link"
                  [ngClass]="{ 'is-locked': isLocked(lockedElements?.logoFile) }" tappable
                  (click)="addImageClicked('logo')" src="assets/imgs/pencil_edit_icon.svg"
                  data-cy="profile-myBrand-logo-emptyIcon" />
                <span *ngIf="userRole !== 'lender' && getLockImage(lockedElements?.logoFile) !== ''">
                  <ion-button fill="clear" (click)="lockMyBrandLogo()">
                    <ion-icon [src]="getLockImage(lockedElements?.logoFile)" class="link "
                      [ngClass]="{ 'is-locked': isLocked(lockedElements?.logoFile) }"></ion-icon>
                  </ion-button>
                </span>
              </div>

            </div>

            <div class="spacer-20"></div>

            <div class="brandWrapper" data-cy="profile-myBrand-logo-library">

              <div class="brandLogo" (click)="confirmModal(image)" tappable
                *ngFor="let image of thumbImages; let index = index" [class.hidden]="index>=maxBrandLogos">
                <img [src]="image">
              </div>

              <ion-button ion-button fill="outline" color="primary" (click)="showMoreLogos()"
                *ngIf="maxBrandLogos === 8">See More
              </ion-button>
            </div>

            <div class="spacer-30"></div>
            <div class="color-picker" data-cy="profile-color-picker">
              <div class="colorbutton primary-color" tappable (click)="pickColor(true)" mode="ios"
                [style.backgroundColor]="primaryColorOpaque" data-cy="profile-myBrand-primaryColor">
                <div class="color-shower" [style.backgroundColor]="primaryColor"></div>
                <label [ngClass]="{ 'is-locked': isLocked(lockedElements?.primaryColor) }">Primary color</label>
                <span [ngClass]="{ 'is-locked': isLocked(lockedElements?.primaryColor) }"
                  *ngIf="userRole !== 'lender' && getLockImage(lockedElements?.primaryColor) !== ''">
                  <ion-icon [src]="getLockImage(lockedElements?.primaryColor)" class="link lockBtn"
                    (click)="lockPrimaryColor($event)"
                    [ngClass]="{ 'is-locked': isLocked(lockedElements?.primaryColor) }"
                    data-cy="profile-myBrand-primaryColor-lock"></ion-icon>
                </span>
              </div>
              <div class="colorbutton secondary-color"
                [ngClass]="{ 'is-locked': isLocked(lockedElements?.secondaryColor) }" tappable
                (click)="pickColor(false)" mode="ios" [style.backgroundColor]="secondaryColorOpaque"
                data-cy="profile-myBrand-secondaryColor">
                <div class="color-shower" [style.backgroundColor]="secondaryColor"></div>
                <label>Secondary
                  color</label>
                <span *ngIf="userRole !== 'lender' && getLockImage(lockedElements?.secondaryColor) !== ''">
                  <ion-icon [src]="getLockImage(lockedElements?.secondaryColor)" class="link lockBtn"
                    (click)="lockSecondaryColor($event)"
                    [ngClass]="{ 'is-locked': isLocked(lockedElements?.secondaryColor) }"
                    data-cy="profile-myBrand-secondaryColor-lock"></ion-icon>
                </span>
              </div>
            </div>


            <!-- <div class="spacer-20"></div>
              <div class="mediumHeaderText">My Reviews</div>
              <div class="spacer-20"></div>

              <div class="reviewsWrapper">

                <div class="reviewsDiv borderBox" *ngFor="let item of userReviews; index as i">
                  <ion-item button="false" lines="none" class="checkbox-form-wrapper" text-wrap>
                    <ion-checkbox slot="start" class="reviewCheckbox" color="primary" mode="ios"
                      [(ngModel)]="item.review.enabled" (ionChange)="toggleReview(item.review, i, $event.detail)">
                    </ion-checkbox>
                    <a class="margin-left-10 reviewStarsLink" (click)="openRatingWindow(item.review, $event)">
                      <div class="standardLabel">{{item.review.name}}</div>
                      <div>
                        <ionic-rating-component *ngIf="item.review.reviewStars" #rating activeIcon="star"
                          defaultIcon="star-outline" activeColor="#FFBB54" defaultColor="#C1C8D7" readonly="true"
                          rating="{{item.review.reviewStars}}" fontSize="18px">
                        </ionic-rating-component>
                        <ion-label *ngIf="!item.review.reviewStars" class="addRatingInfo">Add Rating Info
                        </ion-label>
                      </div>
                    </a>
                  </ion-item>
                </div>

              </div> -->
            <div class="spacer-20" *ngIf="(userRole === 'lender')"></div>
            <div class="mediumHeaderText" *ngIf="(userRole === 'lender')" data-cy="profile-reviews-title">My Reviews
            </div>
            <div class="spacer-20" *ngIf="(userRole === 'lender')"></div>

            <div class="reviewsWrapper" *ngIf="(userRole === 'lender')">

              <div class="reviewsDiv borderBox" *ngFor="let item of userReviews; index as i">
                <ion-item button="false" lines="none" class="checkbox-form-wrapper" text-wrap>
                  <ion-checkbox slot="start" class="reviewCheckbox" color="primary" mode="ios"
                    [(ngModel)]="item.review.enabled" (ionChange)="toggleReview(item.review, i, $event.detail)"
                    [attr.data-cy]="'profile-reviews-' + item.review.id + '-checkbox'">
                  </ion-checkbox>
                  <a class="margin-left-10 reviewStarsLink" (click)="openRatingWindow(item.review, $event)"
                    [attr.data-cy]="'profile-reviews-' + item.review.id + '-label'">
                    <div class="standardLabel">{{item.review.name}}</div>
                    <div>
                      <ionic-rating-component *ngIf="item.review.reviewStars" #rating activeIcon="star"
                        defaultIcon="star-outline" activeColor="#FFBB54" defaultColor="#C1C8D7" readonly="true"
                        rating="{{item.review.reviewStars}}" fontSize="18px"
                        [attr.data-cy]="'profile-reviews-' + item.review.id + '-rating'">
                      </ionic-rating-component>
                      <ion-label *ngIf="!item.review.reviewStars" class="addRatingInfo"
                        [attr.data-cy]="'profile-reviews-' + item.review.id + '-addRatingInfoBtn'">Add Rating Info
                      </ion-label>
                    </div>
                  </a>
                </ion-item>
              </div>

            </div>

            <div class="spacer-30"></div>
            <div class="mediumHeaderText" *ngIf="userData.role !== 'agentAdmin'" data-cy="profile-socialLinks-title">My
              Social Links</div>
            <div class="spacer-20" *ngIf="userData.role !== 'agentAdmin'"></div>

            <ion-reorder-group lines="none" disabled="false" reorder="true"
              (ionItemReorder)="reorderSocialLinks($event)" *ngIf="userData.role !== 'agentAdmin'">
              <ion-item button="false" class="linkHeader" lines="none" *ngFor="let item of socialLinks; index as i">
                <ion-checkbox slot="start" (ionChange)="socialLinkChanged(item, i, $event.detail)"
                  [(ngModel)]="item.enabled" mode="ios" [attr.data-cy]="'profile-socialLinks-' + item.id + '-checkbox'">
                </ion-checkbox>
                <a button class="clickEnableCls bold margin-left-20" (click)="openEditModal('editSocialLink', item)">
                  <span class="urlLinkHeader" [attr.data-cy]="'profile-socialLinks-' + item.id + '-btn-title'">{{
                    item.title }} </span>

                  <ion-label fill="clear" *ngIf="item.URL !== ''" class="normal linkLabel"
                    [attr.data-cy]="'profile-socialLinks-' + item.id + '-btn-url'">{{item.URL}}</ion-label>

                  <ion-label *ngIf="item.URL === ''" class="normal linkLabel urlLink"
                    [attr.data-cy]="'profile-socialLinks-' + item.id + '-btn-addUrl'">Add URL</ion-label>
                </a>
                <ion-reorder lines="none" slot="end"
                  [attr.data-cy]="'profile-socialLinks-' + item.id + '-btn-reorderBtn'"></ion-reorder>
              </ion-item>
            </ion-reorder-group>


            <div class="spacer-10"></div>

          </section>

          <section *ngSwitchCase="'integrations'">

            <div *ngIf="rolloutOptionsShow && showZapierFull">
              <div class="spacer-15"></div>

              <h3>Direct Integrations</h3>

              <app-rollout-integration class="appRollout"></app-rollout-integration>

            </div>


            <!-- temporary rollout option on native -->


            <div class="zapierDiv" *ngIf="!showZapierFull">

              <h3>Direct Integrations</h3>

              <div class="syncLeadDiv borderBox">

                <div class="standardLabel" data-cy="profile-additionalOpt-syncLeads-txt">
                  <span> Configure Integrations in our Web App</span>
                </div>

                <ion-button size="small" class="openZap" (click)="openRolloutSync()"
                  data-cy="profile-additionalOpt-syncLeads-btn">Setup <ion-icon
                    name="open-outline"></ion-icon></ion-button>
              </div>

            </div>

            <div class="spacer-15"></div>

            <div class="zapierWrapper" *ngIf="!showZapierFull">

              <div class="zapierDiv">

                <h3>Integrations via Zapier</h3>

                <div class="syncLeadDiv borderBox">

                  <div class="standardLabel" data-cy="profile-additionalOpt-syncLeads-txt">
                    <span> Connect 5000+ Apps<ion-icon color="primary" tappable (click)="activateInfoAlert(1)"
                        ios="information-circle-sharp" md="information-circle-sharp"
                        data-cy="profile-additionalOpt-syncLeads-infoIcon"></ion-icon></span>
                  </div>

                  <ion-button size="small" class="openZap" (click)="openZapierSync()"
                    data-cy="profile-additionalOpt-syncLeads-btn">Setup <ion-icon
                      name="open-outline"></ion-icon></ion-button>
                </div>

              </div>
            </div>

            <div class="zapierWrapper" *ngIf="showZapierFull">
              <div class="zapierDiv">

                <h3>Integrations via Zapier</h3>

                <div class="syncLeadDiv borderBox" data-cy="profile-additionalOpt-syncLeads-txt">

                  <zapier-full-experience class="zapierClass" [signUpEmail]="userData.email"
                    [signUpFirstName]="firstName" [signUpLastName]="secondName"
                    style="width: auto; margin-top: 10px; font-size: 10px !important;" [introCopyDisplay]='"hide"'
                    [clientId]='"J8r7hOadTE8U7RIqxj4xVZf361y1fXCBrAFaNbQc"' [theme]='"light"'
                    [appSearchBarDisplay]='"show"'></zapier-full-experience>

                </div>
              </div>
            </div>

          </section>

          <section *ngSwitchCase="'additional'">

            <div class="spacer-20"></div>

            <h4 *ngIf="userRole === 'agent'">Open House Options</h4>
            <div *ngIf="userRole === 'agent'" class="spacer-15"></div>
            <div *ngIf="userRole === 'agent'" class="listing-edits">
              <ion-row class="propertyItem intro-wrapper linkWrapper">
                <ion-col class="propertyTitle " data-cy="profile-additionalOpt-signInIntro-lbl">
                  <span class="color-primary">Open House Sign-in Intro</span>
                </ion-col>
                <ion-col (click)="changeIntro($event)"><span class="propertyValue color-primary"
                    data-cy="profile-additionalOpt-signInIntro-btn"> {{introText}} </span>
                </ion-col>
              </ion-row>

              <ion-row class="propertyItem intro-wrapper linkWrapper">
                <ion-col class="propertyTitle" data-cy="profile-additionalOpt-signInOutro-lbl">
                  <span class="color-primary">Open House Sign-in Outro</span>
                </ion-col>
                <ion-col (click)="changeOutro($event)"><span class="propertyValue color-primary"
                    data-cy="profile-additionalOpt-signInOutro-btn"> {{outroText}} </span>
                </ion-col>
              </ion-row>
            </div>

            <div *ngIf="userData.role === 'agent'">
              <div class="spacer-20"></div>
              <label class="profileSubheader" data-cy="profile-mortgageSection-optFields-txt">Mortgage Section <ion-icon
                  style="padding-top:3px;" color="primary" tappable (click)="activateInfoAlert(10)"
                  ios="information-circle-sharp" md="information-circle-sharp">
                </ion-icon></label>

              <div class="spacer-15"></div>

              <ion-list lines="none">
                <ion-radio-group value="start" justify="start" lines="none" [(ngModel)]="selectedMortgageOption"
                  (ionChange)="onMortgageSelect()">
                  <ng-container *ngFor="let question of allMortgageQuestions">
                    <ion-item mode="ios" lines="none" *ngIf="question.active">
                      <ion-radio class="pad-5" value="start" justify="start" labelPlacement="end"
                        [value]="question.id"><span class="bold">"{{
                          question.question }}"</span></ion-radio>
                    </ion-item>
                  </ng-container>

                </ion-radio-group>
              </ion-list>
            </div>

            <div class="spacer-20"></div>


            <div *ngIf="userRole === 'agent'">
              <label class="item-input questionWrap textwrap linkWrapper">
                <div class="flex-nowrap">
                  <span class="input-label row-title color-primary" tappable
                    data-cy="profile-additionalOpt-enableGuestNotes-lbl">
                    Enable New Lead Notification via Text</span>
                  <ion-toggle *ngIf="platformName === 'md'" [disabled]="dataIsLoading" mode="md" color="success"
                    [(ngModel)]="enableGuestSMSFollowUp" (ionChange)="guestSMSnotificationChange()"
                    data-cy="profile-additionalOpt-enableGuestNotes-btn">
                  </ion-toggle>
                  <ion-toggle *ngIf="platformName === 'ios'" [disabled]="dataIsLoading" mode="ios" color="success"
                    [(ngModel)]="enableGuestSMSFollowUp" (ionChange)="guestSMSnotificationChange()"
                    data-cy="profile-additionalOpt-enableGuestNotes-btn">
                  </ion-toggle>
                </div>
              </label>

              <!-- temp code -->
              <!--
                <label class="item-input-2">
                  <div class="flex-nowrap bottom-border">
                    <span class="input-label row-title color-primary" tappable
                      data-cy="profile-additionalOpt-enableGuestNotes-lbl">
                      Mobile Number</span>
                    <ion-label>3109999969</ion-label>
                  </div>
                </label>

                <label class="item-input-2">
                  <div class="flex-nowrap">
                    <span class="" tappable
                      data-cy="profile-additionalOpt-enableGuestNotes-lbl">
                      <ion-checkbox slot="start" class="reviewCheckbox" color="primary" mode="ios">
                      </ion-checkbox>
                    </span>
                    <div class="agreeText">I agree to receive automated transactional messages. Txt and data rates may apply.
                      Reply STOP to end or HELP for help. For more info review our <strong>Terms</strong> and <strong>Privacy Policy here</strong>.
                    </div>
                  </div>
                </label>
                -->
              <!-- temp code -->


              <label *ngIf="userRole === 'agent'" class="item-input questionWrap textwrap linkWrapper">
                <div class="flex-nowrap">
                  <span class="input-label row-title color-primary" tappable
                    data-cy="profile-additionalOpt-enableQrCode-lbl">
                    Enable Touchless Open House QR Code <ion-icon style="padding-top:3px;" color="primary" tappable
                      (click)="activateInfoAlert(5)" ios="information-circle-sharp" md="information-circle-sharp">
                    </ion-icon>
                  </span>
                  <ion-toggle *ngIf="platformName === 'md'" [disabled]="dataIsLoading" mode="md" color="success"
                    [(ngModel)]="userData.touchFreeSignIn" (ionChange)="touchFreeSignInChange()"
                    data-cy="profile-additionalOpt-enableQrCode-btn">
                  </ion-toggle>
                  <ion-toggle *ngIf="platformName === 'ios'" [disabled]="dataIsLoading" mode="ios" color="success"
                    [(ngModel)]="userData.touchFreeSignIn" (ionChange)="touchFreeSignInChange()"
                    data-cy="profile-additionalOpt-enableQrCode-btn">
                  </ion-toggle>
                </div>
              </label>

              <label *ngIf="platform.is('cordova') && userRole === 'agent'"
                class="item-input questionWrap textwrap linkWrapper">
                <div class="flex-nowrap">
                  <span class="input-label row-title color-primary" tappable (click)="showRawLeadLog()">
                    View All Open House Sign-in Logs
                  </span>
                  <ion-icon color="primary" tappable (click)="activateInfoAlert(7)" name="information-circle">
                  </ion-icon>
                </div>
              </label>
            </div>

            <div class="spacer-20"></div>
            <h4 data-cy="profile-legalInfo-optFields-txt">Optional Fields for Microsites
            </h4>

            <div class="spacer-15"></div>

            <label class="item-input questionWrap textwrap linkWrapper">
              <div class="flex-nowrap">
                <span class="input-label row-title color-primary" tappable
                  data-cy="profile-legalInfo-showLicense-txt">Show License</span>

                <ion-toggle *ngIf="platformName === 'md'" [disabled]="dataIsLoading" mode="md" color="success"
                  [(ngModel)]="userData.showLicense" (ionChange)="updateShowLicense()"
                  data-cy="profile-legalInfo-showLicense-toggle">
                </ion-toggle>
                <ion-toggle *ngIf="platformName === 'ios'" [disabled]="dataIsLoading" mode="ios" color="success"
                  [(ngModel)]="userData.showLicense" (ionChange)="updateShowLicense()"
                  data-cy="profile-legalInfo-showLicense-toggle">
                </ion-toggle>
              </div>
            </label>

            <div *ngIf="userData.showLicense" class="information-holder">
              <ion-item color="none" class="linkWrapper" tappable lines="none" (click)="updateUserInformations(7)">
                <span class="input-label" item-start data-cy="profile-legalInfo-showLicense-lbl">License</span>
                <label class="link clear-custome-input full-width" item-end
                  data-cy="profile-legalInfo-showLicense-input">{{userData?.license}}</label>
              </ion-item>
            </div>

            <div *ngIf="userData.showLicense" class="spacer-10"></div>

            <label class="item-input questionWrap textwrap linkWrapper">
              <div class="flex-nowrap">
                <span class="input-label row-title color-primary" tappable>Show Title</span>

                <ion-toggle *ngIf="platformName === 'md'" [disabled]="dataIsLoading" mode="md" [mode]="toggleStyle"
                  color="success" [(ngModel)]="userData.showTitle" (ionChange)="updateShowTitle()">
                </ion-toggle>
                <ion-toggle *ngIf="platformName === 'ios'" [disabled]="dataIsLoading" mode="ios" [mode]="toggleStyle"
                  color="success" [(ngModel)]="userData.showTitle" (ionChange)="updateShowTitle()">
                </ion-toggle>
              </div>
            </label>

            <div *ngIf="userData.showTitle" class="information-holder">
              <ion-item color="none" class="linkWrapper" tappable lines="none" (click)="updateUserInformations(6)">
                <span class="input-label" item-start>Title</span>
                <label class="link clear-custome-input full-width" item-end>{{userData?.title}}</label>
              </ion-item>
            </div>

            <div *ngIf="userData.showTitle" class="spacer-10"></div>

            <label *ngIf="userRole === 'agent'" class="item-input questionWrap textwrap linkWrapper">
              <div class="flex-nowrap">
                <span class="input-label row-title color-primary" tappable
                  data-cy="profile-legalInfo-showDisclaimer1-txt">Show Disclaimer 1</span>
                <ion-toggle *ngIf="platformName === 'md'" [disabled]="dataIsLoading" mode="md" color="success"
                  [(ngModel)]="userData.showDisclaimer" (ionChange)="updateShowDisclaimer(1)"
                  data-cy="profile-legalInfo-showDisclaimer1-toggle">
                </ion-toggle>
                <ion-toggle *ngIf="platformName === 'ios'" [disabled]="dataIsLoading" mode="ios" color="success"
                  [(ngModel)]="userData.showDisclaimer" (ionChange)="updateShowDisclaimer(1)"
                  data-cy="profile-legalInfo-showDisclaimer1-toggle">
                </ion-toggle>
              </div>
            </label>

            <div *ngIf="userData.showDisclaimer" class="information-holder">
              <ion-item color="none" class="linkWrapper" tappable lines="none" (click)="updateUserInformations(8)">
                <span class="input-label" item-start data-cy="profile-legalInfo-showDisclaimer1-txt-lbl">Disclaimer
                  Text</span>
                <label class="link clear-custome-input full-width" item-end
                  data-cy="profile-legalInfo-showDisclaimer1-txt-input">{{userData?.disclaimerText}}</label>
              </ion-item>
              <ion-item color="none" class="linkWrapper" tappable lines="none" (click)="updateUserInformations(9)">
                <span class="input-label" item-start data-cy="profile-legalInfo-showDisclaimer1-url-lbl">Disclaimer
                  URL</span>
                <label class="link clear-custome-input full-width" item-end
                  data-cy="profile-legalInfo-showDisclaimer1-url-input">{{userData?.disclaimerURL}}</label>
              </ion-item>
            </div>

            <div *ngIf="userData.showDisclaimer" class="spacer-10"></div>

            <label class="item-input questionWrap textwrap linkWrapper" *ngIf="userRole === 'agent'">
              <div class="flex-nowrap">
                <span class="input-label row-title color-primary" tappable
                  data-cy="profile-legalInfo-showDisclaimer2-txt">Show Disclaimer 2</span>
                <ion-toggle *ngIf="platformName === 'md'" [disabled]="dataIsLoading" mode="md" color="success"
                  [(ngModel)]="userData.showSecondDisclaimer" (ionChange)="updateShowDisclaimer(2)"
                  data-cy="profile-legalInfo-showDisclaimer2-toggle">
                </ion-toggle>
                <ion-toggle *ngIf="platformName === 'ios'" [disabled]="dataIsLoading" mode="ios" color="success"
                  [(ngModel)]="userData.showSecondDisclaimer" (ionChange)="updateShowDisclaimer(2)"
                  data-cy="profile-legalInfo-showDisclaimer2-toggle">
                </ion-toggle>
              </div>
            </label>

            <div *ngIf="userData.showSecondDisclaimer" class="information-holder">
              <ion-item color="none" class="linkWrapper" tappable lines="none" (click)="updateUserInformations(10)">
                <span class="input-label" item-start data-cy="profile-legalInfo-showDisclaimer2-txt-lbl">Disclaimer
                  Text 2</span>
                <label class="link clear-custome-input full-width" item-end
                  data-cy="profile-legalInfo-showDisclaimer2-txt-input">{{userData?.secondDisclaimerText}}</label>
              </ion-item>
              <ion-item color="none" class="linkWrapper" tappable lines="none" (click)="updateUserInformations(11)">
                <span class="input-label" item-start data-cy="profile-legalInfo-showDisclaimer2-url-lbl">Disclaimer
                  URL 2</span>
                <label class="link clear-custome-input full-width" item-end
                  data-cy="profile-legalInfo-showDisclaimer2-url-input">{{userData?.secondDisclaimerURL}}</label>
              </ion-item>
            </div>

            <div *ngIf="userData.showSecondDisclaimer" class="spacer-10"></div>

            <label *ngIf="userRole === 'agent'" class="item-input questionWrap textwrap linkWrapper disclaimer-wrap">
              <div class="linkWrapper" tappable lines="none">
                <span class="input-label blueFont" item-start data-cy="profile-legalInfo-disclaimerPos-title">Disclaimer
                  Position in Microsite Footer</span>
                <label class="link full-width" item-end>
                  <ion-button class="disclaimer-position-btn button-md" mode="md"
                    [ngClass]="userData.disclaimerPosition === 'above' ? 'active' : 'inactive'" ion-button
                    (click)="setDisclaimerPosition('above')" data-cy="profile-legalInfo-disclaimerPos-aboveBtn">
                    Above Agent Name
                  </ion-button>
                  <ion-button class="disclaimer-position-btn button-md" mode="md"
                    [ngClass]="userData.disclaimerPosition === 'nothing' ? 'active' : 'inactive'" ion-button
                    (click)="setDisclaimerPosition('nothing')" data-cy="profile-legalInfo-disclaimerPos-belowBtn">
                    Below Agent Name</ion-button>
                </label>
              </div>
            </label>

            <div class="spacer-15"></div>

            <h4 *ngIf="userRole === 'agent'" data-cy="profile-legalInfo-optFields-txt"> More Options
            </h4>

            <div class="spacer-20"></div>
            <label *ngIf="userRole === 'agent'" class="item-input questionWrap textwrap linkWrapper">
              <div class="flex-nowrap">
                <span class="input-label row-title color-primary" tappable>Enable Lender Communication <ion-icon
                    style="padding-top:3px;" color="primary" tappable (click)="activateInfoAlert(6)"
                    ios="information-circle-sharp" md="information-circle-sharp"
                    data-cy="profile-additionalOpt-enableLender-lbl"></ion-icon></span>

                <ion-toggle *ngIf="platformName === 'md'" [disabled]="dataIsLoading" mode="md" color="success"
                  [(ngModel)]="userData.enableLenderCommunication" (ionChange)="lenderCommunicationChange()"
                  data-cy="profile-additionalOpt-enableLender-btn">
                </ion-toggle>
                <ion-toggle *ngIf="platformName === 'ios'" [disabled]="dataIsLoading" mode="ios" color="success"
                  [(ngModel)]="userData.enableLenderCommunication" (ionChange)="lenderCommunicationChange()"
                  data-cy="profile-additionalOpt-enableLender-btn">
                </ion-toggle>
              </div>
            </label>

            <change-app-setting *ngIf="userRole === 'agent' || userRole === 'lender'"
              [settingName]="'Marketing Disclosure'" [settingCurrentValue]="customMarketingCommunicationsDisclosure"
              [settingPlaceholder]="'Add Disclosure'" [moreInfoModalProps]="{

                header: 'Marketing Disclosure for Open House Leads',
                message: 'Depending on your jurisdiction, you may need to disclose details on how you plan to use the contact info collected from leads for marketing purposes. More details, including example verbiage, us in our Help Section.',
                moreInfoExternalLink: 'https:/\/curbhe.ro/terms/#addendum'
              }" [modalComponentProps]="{ 
                requireValue: false,
                label: 'Marketing Disclosure', 
                data: customMarketingCommunicationsDisclosure, 
                limit: 300
              }" (onModalClose)="marketingCommunicationsDisclosureChanged($event)"
              [nameFieldTestId]="'profile-legalInfo-marketingDisclosure-txt'"
              [iconTestId]="'profile-legalInfo-marketingDisclosure-infoIcon'" />

            <change-app-setting *ngIf="userRole === 'agent' || userRole === 'lender'"
              [settingName]="'Privacy Policy URL'" [settingCurrentValue]="linkToPrivacy"
              [settingPlaceholder]="'Add URL'" [moreInfoModalProps]="{
                header: 'Your Privacy Policy For Your Guests',
                message: 'Depending on your jurisdiction, you may either need to have a digital privacy policy for Open House guests or have a printed privacy policy available at the Open House. We\'ve added some quick ways to create an online privacy policy in our Help Section.',
                moreInfoExternalLink: 'https:/\/curbhe.ro/terms/#addendum'
              }" [modalComponentProps]="{
                requireValue: false,
                label: 'Link to Privacy Policy', 
                data: linkToPrivacy, 
                limit: 655
              }" (onModalClose)="privacyPolictyChanged($event)"
              [nameFieldTestId]="'profile-legalInfo-privacyPolicy-txt'"
              [iconTestId]="'profile-legalInfo-privacyPolicy-infoIcon'" />

            <div *ngIf="userRole === 'agent'">
              <!-- <label class="item-input questionWrap textwrap linkWrapper">
                  <div class="flex-nowrap">
                    <span class="input-label row-title color-primary" tappable
                      data-cy="profile-additionalOpt-enableGuestNotes-lbl">
                      Enable New Lead Notification via Text</span>
                    <ion-toggle *ngIf="platformName === 'md'" [disabled]="dataIsLoading" mode="md" color="success"
                      tappable [(ngModel)]="enableGuestSMSFollowUp" (ionChange)="guestSMSnotificationChange()"
                      data-cy="profile-additionalOpt-enableGuestNotes-btn">
                    </ion-toggle>
                    <ion-toggle *ngIf="platformName === 'ios'" [disabled]="dataIsLoading" mode="ios" color="success"
                      tappable [(ngModel)]="enableGuestSMSFollowUp" (ionChange)="guestSMSnotificationChange()"
                      data-cy="profile-additionalOpt-enableGuestNotes-btn">
                    </ion-toggle>
                  </div>
                </label> -->

              <!-- temp code -->
              <!--
                <label class="item-input-2">
                  <div class="flex-nowrap bottom-border">
                    <span class="input-label row-title color-primary" tappable
                      data-cy="profile-additionalOpt-enableGuestNotes-lbl">
                      Mobile Number</span>
                    <ion-label>3109999969</ion-label>
                  </div>
                </label>

                <label class="item-input-2">
                  <div class="flex-nowrap">
                    <span class="" tappable
                      data-cy="profile-additionalOpt-enableGuestNotes-lbl">
                      <ion-checkbox slot="start" class="reviewCheckbox" color="primary" mode="ios">
                      </ion-checkbox>
                    </span>
                    <div class="agreeText">I agree to receive automated transactional messages. Txt and data rates may apply.
                      Reply STOP to end or HELP for help. For more info review our <strong>Terms</strong> and <strong>Privacy Policy here</strong>.
                    </div>
                  </div>
                </label>
                -->
              <!-- temp code -->


              <!-- <label *ngIf="userRole === 'agent'" class="item-input questionWrap textwrap linkWrapper">
                  <div class="flex-nowrap">
                    <span class="input-label row-title color-primary" tappable
                      data-cy="profile-additionalOpt-enableQrCode-lbl">
                      Enable Touchless Open House QR Code <ion-icon style="padding-top:3px;" color="primary" tappable
                        (click)="activateInfoAlert(5)" ios="information-circle-sharp" md="information-circle-sharp">
                      </ion-icon>
                    </span>
                    <ion-toggle *ngIf="platformName === 'md'" [disabled]="dataIsLoading" mode="md" color="success"
                      [(ngModel)]="userData.touchFreeSignIn" (ionChange)="touchFreeSignInChange()"
                      data-cy="profile-additionalOpt-enableQrCode-btn">
                    </ion-toggle>
                    <ion-toggle *ngIf="platformName === 'ios'" [disabled]="dataIsLoading" mode="ios" color="success"
                      [(ngModel)]="userData.touchFreeSignIn" (ionChange)="touchFreeSignInChange()"
                      data-cy="profile-additionalOpt-enableQrCode-btn">
                    </ion-toggle>
                  </div>
                </label> -->

              <!-- <label *ngIf="userRole === 'agent'" class="item-input questionWrap textwrap linkWrapper">
                  <div class="flex-nowrap">
                    <span class="input-label row-title color-primary" tappable>Enable Lender Communication <ion-icon
                        style="padding-top:3px;" color="primary" tappable (click)="activateInfoAlert(6)"
                        ios="information-circle-sharp" md="information-circle-sharp"
                        data-cy="profile-additionalOpt-enableLender-lbl"></ion-icon></span>
                    <ion-toggle *ngIf="platformName === 'md'" [disabled]="dataIsLoading" mode="md" color="success"
                      [(ngModel)]="userData.enableLenderCommunication" (ionChange)="lenderCommunicationChange()"
                      data-cy="profile-additionalOpt-enableLender-btn">
                    </ion-toggle>
                    <ion-toggle *ngIf="platformName === 'ios'" [disabled]="dataIsLoading" mode="ios" color="success"
                      [(ngModel)]="userData.enableLenderCommunication" (ionChange)="lenderCommunicationChange()"
                      data-cy="profile-additionalOpt-enableLender-btn">
                    </ion-toggle>
                  </div>
                </label> -->

              <label *ngIf="platform.is('cordova') && userRole === 'agent'"
                class="item-input questionWrap textwrap linkWrapper">
                <div class="flex-nowrap">
                  <span class="input-label row-title color-primary" tappable (click)="showRawLeadLog()">
                    View All Open House Sign-in Logs
                  </span>
                  <ion-icon color="primary" tappable (click)="activateInfoAlert(7)" name="information-circle">
                  </ion-icon>
                </div>
              </label>
            </div>

          </section>

          <section *ngSwitchCase="'disclosures'">

            <div class="spacer-20"></div>

            <div class="rightButton pad-bottom-10">
              <ion-button (click)="alertDisclosures(0)">+ Add Disclosure</ion-button>
            </div>

            <div *ngIf="disclosureDoc" class="disclosureDoc borderBox">

              <div class="container" (click)="alertDisclosures(1)">
                <ion-label color="primary" class="disclosureDocTitle">{{disclosureDoc.title}} <ion-icon
                    src="assets/imgs/lock-closed.svg" class="link"></ion-icon></ion-label>

                <div class="toggle-container">
                  <ion-toggle *ngIf="platformName === 'md'" [disabled]="true" mode="md" color="success"
                    [ngModel]="disclosureDoc.active"></ion-toggle>
                  <ion-toggle *ngIf="platformName === 'ios'" [disabled]="true" mode="ios" color="success"
                    [ngModel]="disclosureDoc.active"></ion-toggle>
                </div>
              </div>

              <div class="spacer-10"></div>

              <div class="borderBox disclosureSub" (click)="alertDisclosures(1)">

                <ion-label class="disclosureSubTitle">Visitor Explanation</ion-label> <ion-icon
                  name="information-circle-outline" class="link"></ion-icon>

                <ion-label color="primary bold" class="floatRight message">{{disclosureDoc.message}}</ion-label>

              </div>

              <div class="spacer-30"></div>

              <ion-label (click)="alertDisclosures(1)" color="primary" class="disclosureDocTitle">Disclosure
                PDF</ion-label> <ion-icon name="information-circle-outline" class="link"></ion-icon>

              <div class="spacer-10"></div>

              <div class="borderBox disclosureSub centerAlign" (click)="alertDisclosures(1)">

                <div class="docDisclosurePdf">
                  <ion-icon src="assets/imgs/document-text-outline.svg" class="link"></ion-icon>
                </div>

                <ion-label>{{disclosureDoc.url}}</ion-label>

              </div>


              <div class="spacer-10"></div>
              <ion-button (click)="alertDisclosures(2)" fill="outline" class="fullWidth">Export Signed
                Disclosures</ion-button>

            </div>

          </section>

        </div>
      </div>

      <div class="spacer-20"></div>
      <ion-button ion-button (click)="goHomeLogin()" class="logout" data-cy="profile-logoutBtn">
        <label>Logout</label>
      </ion-button>


      <div class="spacer-20"></div>
      <div class="pad-10">
        <ion-label *ngIf="cordova" class="deleteAccount normal link linkLabel urlLink"
          (click)="promptDeleteAccount()">Delete Account
        </ion-label>
      </div>


      <div class="spacer-10"></div>
      <div class="appVersionSpan pad-10">{{env.appversion}}</div>

      <div class="spacer-20"></div>
    </div>
  </div>

  <div *ngIf="cordova && (userData.role === 'lender' || userData.role === 'agentAdmin')" class="skeleton-holder">
    <div class="nativeLender blockBox centerBox centerAlign">
      <img src="/assets/imgs/openWebApp.png">
      <div class="label">
        {{userRoleHeader}} functionality is not available in our mobile app yet. Our web app is fully functional
        though!
      </div>
      <ion-button ion-button tappable (click)="visitWebApp()" color="primary">
        Visit Web App
      </ion-button>
    </div>

    <div class="spacer-20"></div>
    <ion-button ion-button small (click)="goHomeLogin()" class="logout2">
      <label>Logout</label>
    </ion-button>

    <div class="spacer-10"></div>
    <div class="appVersionSpan">{{env.appversion}}</div>

    <div class="spacer-20"></div>
  </div>
</ion-content>